const SB_CHANGES_MODAL_ENABLED = false;

class SubscriptionBuilderFooter extends HTMLElement {
  constructor() {
    super();

    // Properties
    this._bundle = [];
    this.bundleSize = 0;
    this.discountPercentage = 0;
    this.totalPrice = 0;
    this.discountedPrice = 0;
    this.initialized = false;
    this.sellingPlanGroup = {};
    this.sellingPlans = [];
    this._builderType = 'new';
    this._bundleToEdit = [];
    this._currentEditingSubscription = null;
    this._subVersion = 'v3';
    this._isPdpClubToggleOn = false;
    this.isJanPromoEnabled = false;

    this.subscriptionProductsMeta = window.__abc?.subscription_products_meta || [];
    // Subscription product details
    this.subscriptionProductHandle = this.getAttribute('subscription-product-handle');
    this.subscriptionProductId = this.getAttribute('subscription-product-id');
    this.subscriptionVariantId = this.getAttribute('subscription-variant-id');
    this.subscriptionCollectionId = this.getAttribute('subscription-collection-id');

    this._selectedSellingPlanId = null;

    this._clubMembershipToggleOn = false;
    this.addToCartButton = null;
    this._sbCartConfirmed = false;
    this._sbModal = null;
    this.handleRemoveItemClick = this.handleRemoveItemClick.bind(this);
    this.handleAddToCartClick = this.handleAddToCartClick.bind(this);
    this.handleSbModalClose = this.handleSbModalClose.bind(this);

    this.cart =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  // Getters and Setters

  set isPdpClubToggleOn(value) {
    this._isPdpClubToggleOn = value;
  }

  get isPdpClubToggleOn() {
    return this._isPdpClubToggleOn;
  }

  set subVersion(value) {
    this._subVersion = value;
  }

  get subVersion() {
    return this._subVersion;
  }

  set bundle(value) {
    this._bundle = value;
  }

  get bundle() {
    return this._bundle;
  }

  set currentEditingSubscription(value) {
    this._currentEditingSubscription = value;
  }

  get currentEditingSubscription() {
    return this._currentEditingSubscription;
  }

  set selectedSellingPlanId(value) {
    this._selectedSellingPlanId = value;
  }

  get selectedSellingPlanId() {
    return this._selectedSellingPlanId;
  }

  set clubMembershipToggleOn(value) {
    this._clubMembershipToggleOn = value;
  }

  get clubMembershipToggleOn() {
    return this._clubMembershipToggleOn;
  }

  set builderType(value) {
    this._builderType = value;
  }

  get builderType() {
    return this._builderType;
  }

  set bundleToEdit(value) {
    this._bundleToEdit = value;
  }

  get bundleToEdit() {
    return this._bundleToEdit;
  }

  // Lifecycle Methods
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;

    try {
      this.sellingPlanGroup = JSON.parse(this.getAttribute('selling-plan-group'));
      this.sellingPlans = this.sellingPlanGroup.selling_plans;
    } catch (e) {
      console.error('Invalid JSON for selling-plan-group attribute:', e);
    }

    //console.log('Selling Plan Group:', this.sellingPlanGroup);

    this.addToCartButton = this.querySelector('.sb-add-to-cart-button');
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', this.handleAddToCartClick);
    }

    this._sbModal = document.getElementById('sb-changes-modal');
    this._sbModal?.addEventListener('close', this.handleSbModalClose);

    this.updateUI();
  }

  disconnectedCallback() {
    if (this.addToCartButton) {
      this.addToCartButton.removeEventListener('click', this.handleAddToCartClick);
    }

    this._sbModal?.removeEventListener('close', this.handleSbModalClose);

    const buttons = this.querySelectorAll('.bundle_item');
    buttons.forEach((button) => {
      button.removeEventListener('click', this.handleButtonClick);
    });
    this.initialized = false;
  }

  // Event Handlers
  handleSbModalClose(e) {
    if (e.target.returnValue === 'continue') {
      this._sbCartConfirmed = true;
      this.handleAddToCartClick(new Event('click'));
    }
  }

  addBundleToCart(updatedBundleItems) {
    const toSend = {};
    toSend.items = updatedBundleItems;
    toSend.sections = this.cart.getSectionsToRender().map((section) => section.id);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(toSend);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        /*
       console.log('Cart Add Response:', response);
        console.log('response.status', response.status);
        console.log('this.cart', this.cart);
        */

        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        //console.log('this.subscriptionVariantId', this.subscriptionVariantId);
        //console.log('response', response);
        //console.log('this.error', this.error);
        if (!this.error)
          this.dispatchEvent(
            new CustomEvent('closeSubscriptionBuilder', {
              bubbles: true,
              composed: true,
            })
          );

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'subscription-builder',
          productVariantId: this.subscriptionVariantId,
          cartData: response,
        });
        this.error = false;
        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        /*
          *** update current builder ATC to use the spinner logic below

          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty'))
            this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          */

        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
      });
  }

  quickRemove(products) {
    const toRemovePayload = products.reduce((acc, i) => {
      acc[i.key] = 0;
      return acc;
    }, {});

    //console.log('toRemovePayload', toRemovePayload);

    const toSend = {};
    toSend.updates = toRemovePayload;

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(toSend);

    // Return a promise to handle async operations
    return fetch(`${routes.cart_update_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // Handle error
          console.error('Error removing items from cart:', response);
          throw new Error(response.description || 'Failed to remove items from cart');
        } else {
          console.log('Successfully removed items from cart');
          return response;
        }
      })
      .catch((e) => {
        console.error('Fetch error in quickRemove:', e);
        throw e;
      });
  }

  async handleAddToCartClick(event) {
    event.preventDefault();

    if (SB_CHANGES_MODAL_ENABLED && !this._sbCartConfirmed && this._sbModal) {
      this._sbModal.showModal();
      return;
    }
    this._sbCartConfirmed = false;

    const sellingPlan = this.sellingPlans.find((plan) => plan.id == this._selectedSellingPlanId);
    const sellingPlanToFind = sellingPlan?.name;

    if (!sellingPlan) {
      console.error('Selling plan not found');
      return;
    }
    //isPdpClubToggleOn

    // console.log('this._isPdpClubToggleOn', this._isPdpClubToggleOn);

    // Prepare bundle product data
    const bundleProductData = {
      productId: this.subscriptionProductId,
      variantId: this.subscriptionVariantId,
      sellingPlan: sellingPlan.id,
      handle: this.subscriptionProductHandle,
    };

    const customProperties = {
      __orderType: 'first',
      __subscriptionVersion: 'v3',
    };

    const tempPayload = this._bundle.reduce((accumulator, product) => {
      const defaultSellingPlan = product.selling_plan_groups[0].selling_plans.find(
        (plan) => plan.name === sellingPlanToFind
      );

      if (!defaultSellingPlan) {
        return accumulator;
      }

      const variantId = product.variants[0].id;

      if (this.builderType === 'editActiveSubscription') {
        if (!accumulator[variantId]) {
          accumulator[variantId] = {
            collection_id: '277396947025',
            collection_source: 'shopify',
            external_variant_id: variantId.toString(),
            external_product_id: product.id.toString(),
            quantity: 1,
          };
        } else {
          accumulator[variantId].quantity++;
        }
      } else {
        if (!accumulator[variantId]) {
          accumulator[variantId] = {
            collectionId: this.subscriptionCollectionId,
            externalVariantId: variantId,
            externalProductId: product.id,
            sellingPlan: defaultSellingPlan.id,
            quantity: 1,
          };
        } else {
          accumulator[variantId].quantity++;
        }
      }

      return accumulator;
    }, {});

    const payload = Object.values(tempPayload);

    const finalBundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: payload,
    };

    const bundleItems = recharge.bundle.getDynamicBundleItems(
      finalBundle,
      this.subscriptionProductHandle
    );

    const updatedBundleItems = bundleItems.map((item) => ({
      ...item,
      properties: {
        ...item.properties,
        ...customProperties,
      },
    }));

    if (this._builderType == 'edit') {
      //console.log('odBundleItems', updatedBundleItems);

      try {
        await this.quickRemove(this._bundleToEdit);
        this.addBundleToCart(updatedBundleItems);
      } catch (error) {
        console.error('Error during quickRemove:', error);
        this.handleErrorMessage(error.message);
      }
    } else if (this._builderType == 'editActiveSubscription') {
      const toSend = {
        purchase_item_id: this._currentEditingSubscription.include.bundle_selections.id,
        items: payload,
      };
      try {
        this.addToCartButton.innerText = 'Saving...';
        this.addToCartButton.disabled = true;
        await recharge.bundle.updateBundleSelection(
          this.getSession(),
          this._currentEditingSubscription.include.bundle_selections.id,
          toSend
        );

        const customerPortal = document.querySelector('customer-portal');
        if (customerPortal) {
          await customerPortal.getSubscriptions(false);
        }

        triggerToast({
          title: 'Success!',
          message: 'Your bundle has been updated',
          status: 'success',
          position: 'top-right',
          size: 'large',
          duration: 5000,
        });
        this.dispatchEvent(
          new CustomEvent('closeSubscriptionBuilder', {
            bubbles: true,
            composed: true,
          })
        );
        /*
        const customerPortal = document.querySelector('customer-portal');
        if (customerPortal) {
          await customerPortal.loadSubscriptions();
          await customerPortal.getCharges();
        }
          */
      } catch (error) {
        console.error('Error during updateBundleSelection:', error);
        this.handleErrorMessage(error.message);
      } finally {
        this.addToCartButton.innerText = 'Save Changes';
        this.addToCartButton.disabled = false;
      }
    } else {
      const cartData = window.__abc?.ShopifyCartData.cart;
      const clubProduct = window.__abc?.clubProduct;

      if (
        clubProduct &&
        clubProduct.variants?.[0] &&
        clubProduct.selling_plan_groups?.[0]?.selling_plans?.[0] &&
        this._isPdpClubToggleOn
      ) {
        const isClubInCart = cartData.items.some((item) => item.id === clubProduct.variants[0].id);
        if (!isClubInCart) {
          const clubProductToAdd = {
            id: clubProduct.variants[0].id,
            quantity: 1,
            selling_plan: clubProduct.selling_plan_groups[0].selling_plans[0].id,
          };
          updatedBundleItems.push(clubProductToAdd);
        }
      }
      this.addBundleToCart(updatedBundleItems);
    }
  }

  getSession() {
    const session = sessionStorage.getItem('abc_recharge_session');
    return session ? JSON.parse(session) : null;
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    /*
    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage =
      this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
    */
    console.error({ errorMessage });
  }

  updatePrices() {
    this.bundleSize = this._bundle.length;

    // Calculate totalPrice once
    this.totalPrice = this.calculateTotalPrice();

    if (this.isJanPromoEnabled && this.builderType !== 'editActiveSubscription') {
      this.discountedPrice = this.calculateJanPromoDiscountedPrice();
      this.discountPercentage = null; // Variable discount per item in this case
    } else if (this.clubMembershipToggleOn && this.bundleSize >= 4) {
      this.discountedPrice = this.calculateSpecialDiscountedPrice();
      this.discountPercentage = null; // No percentage discount in this case
      //  console.log('123', this.discountedPrice);
      // console.log('123', this.totalPrice);
    } else {
      const discountUtils = window.__abc?.subscriptionDiscount;
      this.discountedPrice = discountUtils
        ? discountUtils.calculateVolumeDiscountedTotal(this._bundle, this.bundleSize)
        : this.totalPrice;

      const tierPct = discountUtils
        ? discountUtils.getVolumeDiscountPercentage(this.bundleSize)
        : 0;
      this.discountPercentage =
        tierPct > 0 && discountUtils?.hasEligibleDiscountedLines(this._bundle, this.bundleSize)
          ? tierPct
          : null;
    }
  }

  calculateTotalPrice() {
    return this._bundle.reduce((sum, product) => {
      const price = parseFloat(product.price);
      return isNaN(price) ? sum : sum + price;
    }, 0);
  }

  calculateSpecialDiscountedPrice() {
    return this._bundle.reduce((sum, product) => {
      //console.log('Product:', product, this.calculateSpecialPrice(product));
      return sum + this.calculateSpecialPrice(product);
    }, 0);
  }

  calculateSpecialPrice(product) {
    return product.tags.includes('beer') ? 1099 : 899;
  }

  updateProperties({
    bundle,
    selectedSellingPlanId,
    clubMembershipToggleOn,
    builderType,
    bundleToEdit,
    currentEditingSubscription,
    subVersion,
    isPdpClubToggleOn,
  }) {
    this.bundle = bundle;
    this.selectedSellingPlanId = selectedSellingPlanId;
    this.clubMembershipToggleOn = clubMembershipToggleOn;
    this.builderType = builderType;
    this.bundleToEdit = bundleToEdit;
    this.currentEditingSubscription = currentEditingSubscription;
    this.subVersion = subVersion;
    this.isPdpClubToggleOn = isPdpClubToggleOn;
    this.updatePrices();
    this.updateUI();
    this.updateProductStrip();
  }

  updateUI() {
    // Update Price Section
    const priceSection = this.querySelector('.sb-price-section');
    if (priceSection) {
      const originalPriceElement = priceSection.querySelector('.original-price');
      const discountedPriceElement = priceSection.querySelector('.discounted-price');

      if (this.discountedPrice > 0 && this.discountedPrice < this.totalPrice) {
        originalPriceElement.style.display = 'block';
        originalPriceElement.textContent = `$${(this.totalPrice / 100).toFixed(2)}`;
      } else if (originalPriceElement) {
        originalPriceElement.style.display = 'none';
      }

      if (discountedPriceElement) {
        discountedPriceElement.textContent = `$${(this.discountedPrice / 100).toFixed(2)}`;
      }
    }

    const clubBadgeWrapper = this.querySelector('.club-badge-wrapper');
    if (clubBadgeWrapper) {
      clubBadgeWrapper.style.display = this.clubMembershipToggleOn ? 'block' : 'none';
    }

    // Update Progress Message
    const progressMsgElement = this.querySelector('.sb-progress-msg');
    if (progressMsgElement) {
      progressMsgElement.textContent = this.getProgressMessage(this.bundleSize);
    }
    //console.log('this._builderType', this._builderType);
    if (this._builderType === 'edit') {
      this.addToCartButton.textContent = `Edit Bundle`;
    } else if (this._builderType === 'editActiveSubscription') {
      this.addToCartButton.textContent = `Save Changes`;
    } else {
      this.addToCartButton.textContent = `Add to Cart`;
    }

    // Update Add to Cart Button State
    if (this.addToCartButton) {
      if (this.subVersion == 'v3a') {
        this.addToCartButton.disabled = this.bundleSize < 2;
      } else {
        this.addToCartButton.disabled = this.bundleSize < 3;
      }
    }
  }

  calculateJanPromoDiscountedPrice() {
    // Sort products by price (lowest first)
    const sortedBundle = [...this._bundle].sort((a, b) => {
      const priceA = parseFloat(a.price) || 0;
      const priceB = parseFloat(b.price) || 0;
      return priceA - priceB;
    });

    let discountedTotal = 0;

    sortedBundle.forEach((product, index) => {
      const price = parseFloat(product.price) || 0;
      // First 8 items get 50% off, rest get 15% off
      if (index < 8) {
        discountedTotal += price * (1 - 0.5);
      } else {
        discountedTotal += price * (1 - 0.15);
      }
    });

    return discountedTotal;
  }

  getProgressMessage(bundleSize) {
    if (bundleSize >= 5) {
      return "Great! Add as many 6-packs as you'd like.";
    } else if (bundleSize === 4) {
      return 'Add 1 more 6-pack to save 15% on limited and pilot brews.';
    } else if (bundleSize === 3) {
      return 'Add 1 more 6-pack to save 10% on limited and pilot brews.';
    } else {
      return 'Subscriptions require a minimum of three 6-packs.';
    }
  }

  updateProductStrip() {
    const bundleListElement = this.querySelector('.bundle-list');

    const emptyBundleTemplate = document.getElementById('empty-bundle-item');
    const bundleItemEl = document.getElementById('bundle-item');
    bundleListElement.innerHTML = '';

    this._bundle.forEach((product, index) => {
      const productMeta = this.subscriptionProductsMeta.find((meta) => meta.id === product.id);
      const newBundleItem = bundleItemEl.content.cloneNode(true);

      // Target the button element within the cloned template
      const bundleButton = newBundleItem.querySelector('.bundle_item');
      if (bundleButton) {
        bundleButton.setAttribute('aria-label', 'Remove ' + product.title + ' from bundle');
        bundleButton.setAttribute('aria-controls', 'bundle-item-' + index);
        bundleButton.setAttribute('role', 'button');
        bundleButton.setAttribute('data-product-id', product.id);
        bundleButton.setAttribute('tabindex', '0');

        bundleButton.addEventListener('click', this.handleRemoveItemClick.bind(this, product));
      }
      console.log('product', product);
      const bundleItemContent = newBundleItem.querySelector('.bundle_item_content');
      bundleItemContent.style.backgroundColor =
        productMeta?.productMetafields?.product_background_color;

      const bundleItemImg = newBundleItem.querySelector('.bundle_item_img');
      const bundleItemTitle = newBundleItem.querySelector('.bundle_item_title');
      const isBotm = Array.isArray(product.tags) && product.tags.includes('botm');

      if (bundleItemTitle) {
        bundleItemTitle.textContent = product.title;
      }
      if (bundleItemImg) {
        bundleItemImg.src = product.featured_image + '&width=200';
        bundleItemImg.alt = product.title || '';
        if (isBotm) {
          bundleItemImg.classList.add('botm_product_image');
        }
      }

      const botmBannerUrl = this.getAttribute('data-botm-banner-url');
      if (bundleItemContent && isBotm && botmBannerUrl) {
        const bannerImg = document.createElement('img');
        bannerImg.src = botmBannerUrl;
        bannerImg.alt = '';
        bannerImg.className = 'botm_product_image_banner';
        bundleItemContent.appendChild(bannerImg);
      }

      bundleListElement.appendChild(newBundleItem);
    });

    if (this._bundle.length <= 5) {
      for (let i = this._bundle.length; i < 6; i++) {
        if (emptyBundleTemplate) {
          const emptyBundleClone = emptyBundleTemplate.content.cloneNode(true);
          const counterBadge = emptyBundleClone.querySelector('.counter_badge');
          if (counterBadge) {
            counterBadge.textContent = i + 1;
          }
          bundleListElement.appendChild(emptyBundleClone);
        }
      }
    } else {
      if (emptyBundleTemplate) {
        const i = this._bundle.length;
        const emptyBundleClone = emptyBundleTemplate.content.cloneNode(true);
        const counterBadge = emptyBundleClone.querySelector('.counter_badge');
        if (counterBadge) {
          counterBadge.textContent = i + 1;
        }
        bundleListElement.appendChild(emptyBundleClone);
      }
    }
  }

  handleRemoveItemClick(product, event) {
    event.preventDefault();
    //  console.log('Product removed:', product);

    const productsInBundle = this._bundle.filter((item) => item.id == product.id);

    const newQty = productsInBundle.length - 1;
    const eventDetail = { product: product, quantity: newQty };
    this.dispatchEvent(
      new CustomEvent('remove_item_from_bundle', {
        detail: eventDetail,
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define('subscription-builder-footer', SubscriptionBuilderFooter);
